/* ALIVENESS (2026-07-19) — prémium élőség, kutatás-vezérelt, minimál-barát.
   Teljesen kikapcsol prefers-reduced-motion alatt. Csak transform/opacity + rAF.
   NINCS magnetikus gomb / egyedi kurzor (a kutatás szerint ütközik az arculattal). */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  /* 1) KURZOR-FÉNY — csak valódi mutatóval (desktop), rAF-lerp, blur nélkül a loopban */
  if (window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches) {
    var glow = document.querySelector('.alv-cursor');
    if (glow) {
      var tx = innerWidth / 2, ty = innerHeight * 0.4, cx = tx, cy = ty, on = false;
      addEventListener('pointermove', function (e) {
        tx = e.clientX; ty = e.clientY;
        if (!on) { on = true; glow.classList.add('is-on'); }
      }, { passive: true });
      (function loop() {
        cx += (tx - cx) * 0.12; cy += (ty - cy) * 0.12;
        glow.style.setProperty('--mx', cx + 'px');
        glow.style.setProperty('--my', cy + 'px');
        requestAnimationFrame(loop);
      })();
    }
  }

  /* 2) SCROLL-REVEAL (opt-in .alv-reveal / .alv-imgclip) — egyszer, stagger a DOM-sorrend szerint */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('alv-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.alv-reveal, .alv-imgclip').forEach(function (el) {
      // auto-stagger: hányadik a szülőn belül
      var sibs = el.parentElement ? [].indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--alv-i', Math.min(sibs, 8));
      io.observe(el);
    });

    /* 3) COUNT-UP — a bizonyíték-számokra (meglévő .dstrust__num + opt-in .alv-count).
       Csak akkor animál, ha a szöveg TISZTÁN szám(+utótag); különben békén hagyja. */
    var cuio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { countUp(en.target); cuio.unobserve(en.target); }
      });
    }, { threshold: 0.6 });
    document.querySelectorAll('.alv-count, .dstrust__num').forEach(function (el) { cuio.observe(el); });

    /* 4) SVG INK-DRAW — a FIELD-diagramok "megrajzolódnak" scrollra: a stroke-ös elemek
       vonalként húzódnak, a filled elemek finoman beúsznak. Ez a márka ink-on-paper
       nyelvének NATÍV mozgása (a kutatás #1 on-brand ötlete). Csak sizable diagramon. */
    if ('getTotalLength' in (window.SVGGeometryElement || {}).prototype) {
      // A rejtés CSAK a rajzolás pillanatában történik (amikor a diagram láthatóvá válik),
      // rögtön követi az animáció → SOSE marad tartósan láthatatlan (biztonságos fallback).
      var drawIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { inkDraw(en.target); drawIO.unobserve(en.target); } });
      }, { threshold: 0.18, rootMargin: '0px 0px -5% 0px' });
      var seen = [];
      document.querySelectorAll('.ucp__svg, .ucp__dgm, [class*="svgwrap"] svg, .dsno__svgwrap svg, .bro-tl svg, #MainContent .rte svg, #MainContent figure > svg, .ucp__fig svg').forEach(function (svg) {
        if (seen.indexOf(svg) > -1) return; seen.push(svg);
        // KIZARVA: sajat interakcioval biro precizios diagramok (pl. melyseg-felfedezo)
        if (svg.closest('.dx__fig, [data-no-ink]')) return;
        var r = svg.getBoundingClientRect();
        if (r.width < 130 || r.height < 90) return;                  // apró ikonokat kihagyjuk
        var n = svg.querySelectorAll('path,line,polyline,polygon,circle,ellipse,rect').length;
        if (n === 0 || n > 90) return;                               // túl sok elem = jank → kihagyjuk
        drawIO.observe(svg);
      });
      function shapeLen(el) {
        var t = el.tagName.toLowerCase();
        try {
          if (t === 'rect') { return 2 * (el.width.baseVal.value + el.height.baseVal.value); }
          if (t === 'circle') { return 2 * Math.PI * el.r.baseVal.value; }
          if (t === 'ellipse') { var a = el.rx.baseVal.value, b = el.ry.baseVal.value; return Math.PI * (3 * (a + b) - Math.sqrt((3 * a + b) * (a + 3 * b))); }
          if (typeof el.getTotalLength === 'function') { return el.getTotalLength(); }  // path/line/polyline/polygon
        } catch (e) {}
        return 0;
      }
      function inkDraw(svg) {
        var shapes = svg.querySelectorAll('path,line,polyline,polygon,circle,ellipse,rect');
        var strokes = [], fills = [];
        for (var i = 0; i < shapes.length; i++) {
          var el = shapes[i], cs = getComputedStyle(el), sw = parseFloat(cs.strokeWidth) || 0;
          var stroked = cs.stroke && cs.stroke !== 'none' && sw > 0;
          var len = stroked ? shapeLen(el) : 0;   // megbízható per-alakzat kerület (nem getTotalLength a rect/circle-ön)
          if (len > 1 && len < 9000) {
            el.style.strokeDasharray = len; el.style.strokeDashoffset = len; strokes.push(el);
          } else { el.style.opacity = '0'; fills.push(el); }  // filled → beúszik
        }
        var base = Math.min(strokes.length, 8) * 55 + 140;
        requestAnimationFrame(function () {
          strokes.forEach(function (el, i) {
            el.style.transition = 'stroke-dashoffset .95s cubic-bezier(.16,1,.3,1) ' + (Math.min(i, 22) * 55) + 'ms';
            el.style.strokeDashoffset = '0';
          });
          fills.forEach(function (el, j) {
            el.style.transition = 'opacity .55s ease ' + (base + Math.min(j, 20) * 38) + 'ms';
            el.style.opacity = '1';
          });
        });
      }
    }
  }

  function countUp(el) {
    var raw = (el.getAttribute('data-to') || el.textContent || '').trim();
    var m = raw.match(/^([\d\s.,]+)\s*(.*)$/);
    if (!m) return;
    var numStr = m[1].replace(/\s/g, '');
    var decimal = numStr.indexOf(',') > -1 && numStr.indexOf('.') === -1;
    var target = parseFloat(numStr.replace(/\./g, '').replace(',', '.'));
    if (!isFinite(target) || target <= 0) return;
    var suffix = m[2] || '';
    var intLike = Number.isInteger(target) && !decimal;
    var dur = Math.min(2200, 900 + target.toString().length * 220), start = null;
    function ease(t) { return 1 - Math.pow(2, -10 * t); } // expo-out
    function fmt(v) {
      return (intLike ? Math.round(v) : Math.round(v * 10) / 10)
        .toLocaleString('hu-HU') + (suffix ? ' ' + suffix : '');
    }
    el.textContent = fmt(0);
    function tick(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / dur);
      el.textContent = fmt(target * ease(t));
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = target.toLocaleString('hu-HU') + (suffix ? ' ' + suffix : '');
    }
    requestAnimationFrame(tick);
  }
})();
